import { render, staticRenderFns } from "./CustomizeEditChapterPop.vue?vue&type=template&id=0843ab0e"
import script from "./CustomizeEditChapterPop.vue?vue&type=script&lang=js"
export * from "./CustomizeEditChapterPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports